import React, { useState } from "react";
import ReactDatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

const DatePicker = ({ startDate, setStartDate }) => {
  return (
    <ReactDatePicker
      className="form-control"
      selected={startDate}
      dateFormat="dd/MM/yyyy"
      onChange={(date) => setStartDate(date)}
    />
  );
};
export default DatePicker;
